import { Button, Dialog, Portal, Text } from '@chakra-ui/react'

type Props = {
  open: boolean
  onLater: () => void
  onReview: () => void
}

export function InvoiceSettingsMigrationDialog({ open, onLater, onReview }: Props) {
  return (
    <Dialog.Root open={open} onOpenChange={d => !d.open && onLater()}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW="680px">
            <Dialog.Header>
              <Dialog.Title>Rechnungsdaten prüfen</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text>
                Wir haben die Rechnungsdaten von den allgemeinen Nutzerdaten getrennt. Ihre
                bisherigen Angaben wurden automatisch übernommen. Bitte prüfen Sie Ihre
                Rechnungsdaten und bestätigen oder korrigieren Sie diese.
              </Text>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="outline" onClick={onLater}>
                Später prüfen
              </Button>

              <Button colorPalette="blue" onClick={onReview}>
                Rechnungsdaten prüfen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
